import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { OAuthButton } from '../oauth/OAuthButton';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { getIsMicrosoftLoading } from '../store/app/selectors';
import { useLoadMicrosoft } from './useLoadMicrosoft';
import { useMicrosoft } from './useMicrosoft';
export const MicrosoftButton = () => {
  const {
    onClick
  } = useMicrosoft();
  const isAuthLoading = useSelector(getIsMicrosoftLoading);
  const {
    isLoading: isScriptLoading
  } = useLoadMicrosoft();
  return /*#__PURE__*/_jsx(OAuthButton, {
    isLoading: isScriptLoading || isAuthLoading,
    oauth: OAuthProviders.Microsoft,
    onClick: onClick
  });
};